import React from "react";
import PolicyLayout from "@/components/PolicyLayout";

export default function Disclaimer() {
  return (
    <PolicyLayout
      title="Disclaimer"
      description="PeptiChill is temperature-controlled storage equipment. It is not a medical device and does not provide medical advice."
      path="/disclaimer"
      eyebrow="Important information"
      lastUpdated="February 2026"
    >
      <h2>Storage equipment only</h2>
      <p>
        PeptiChill products are <strong>storage equipment only</strong>. They are designed
        to provide a compact, temperature-controlled environment for storage of research-use
        peptides and other temperature-sensitive laboratory materials.
      </p>

      <h2>No medical advice</h2>
      <p>
        Nothing on this website constitutes medical, pharmaceutical or clinical advice.
        PeptiChill does not diagnose, treat, cure or prevent any disease or condition, and
        we make no claims regarding the preservation of efficacy of any specific peptide,
        medicine or biological material.
      </p>
      <p>
        If you have questions about the storage or use of any medicine or research material,
        please follow the instructions provided by your{" "}
        <strong>pharmacist, prescriber, manufacturer or supplier</strong>, or speak to a
        qualified healthcare professional.
      </p>

      <h2>Follow supplier instructions</h2>
      <p>
        Always follow the storage instructions supplied with your research materials,
        medicines or other temperature-sensitive products. Storage requirements vary by
        product, and the user is responsible for ensuring PeptiChill is operated within
        the conditions appropriate for what they intend to store.
      </p>

      <h2>Intended use</h2>
      <p>
        PeptiChill is intended for use in home lab, clinic, research and professional
        storage environments where a compact, clean, temperature-controlled storage
        solution is required. It is not intended for use as a vaccine refrigerator or for
        clinical pharmacy use unless permitted under the conditions of your governing
        authority.
      </p>

      <h2>No warranty of biological stability</h2>
      <p>
        While PeptiChill is engineered to provide an internal temperature in the 2–8 °C
        range, we make <strong>no warranty</strong> that the biological stability, potency
        or efficacy of stored materials will be maintained. That is a function of the
        material itself and conditions outside our control.
      </p>

      <h2>Compliance &amp; safety</h2>
      <p>
        You are responsible for ensuring that your storage and handling of research-use or
        medicinal products complies with all applicable UK laws and regulations.
      </p>

      <h2>Questions</h2>
      <p>
        Contact us at{" "}
        <a href="mailto:hello@peptidecooler.co.uk">hello@peptidecooler.co.uk</a>{" "}
        if you have any questions about whether PeptiChill is right for your storage
        needs.
      </p>
    </PolicyLayout>
  );
}
